import React from "react";

import config from "appConfig";

import {
  scrollToTop,
} from "../../../../services";

import getWidthContext from "../../../../HOCs/getWidthContext";
import LogList from "../LogList";
import { IndexPagination } from "../../../../components/IndexPagination";
import { Spin } from "antd";
function PaginationLog({
  log,
  handlePageChange,
  emptyLogText,
  loading,
  columns
}) {
  const handlePageNumberChange = (page: any, pageSize: any) => {
    handlePageChange(page, pageSize);
    scrollToTop();
  };

  return log ? (
    <React.Fragment>
      <LogList
        columns={columns}
        loading={loading}
        log={log.data}
        emptyLogText={emptyLogText}
      />
      {log.count > config.maxAdPerPage / 4 ? (
        <IndexPagination
          total={log.count}
          page={log.page}
          itemPerPage={config.maxAdPerPage / 4}
          onPageChange={handlePageNumberChange}
        />
      ) : null}
    </React.Fragment>
  ) : (
    <Spin
      tip={"Učitavam..."}
      size="small"
    />
  );
}

PaginationLog.defaultProps = {
  adCardProps: {},
  log: null,
  responsiveProps: {},
  gutter: 0,
  emptyLogText: undefined,
  paginationClassName: ""
};

export default getWidthContext(PaginationLog);



// WEBPACK FOOTER //
// ./src/routes/Admin/Log/PaginationLog/index.tsx